import { gql } from "@apollo/client"
import { getClient } from "lib/apolloClient"
import type {
  DiscoveryJourneyApiResponse,
  DiscoveryJourneySlides,
} from "./types"

export const DISCOVERY_JOURNEY_SLIDES_QUERY = gql`
  query getDiscoveryJourneySlides {
    getDiscoveryJourneySlides {
      slides {
        id
      }
    }
  }
`

export const getDiscoveryJourneySlides = async (): Promise<
  DiscoveryJourneySlides[]
> => {
  const client = getClient()

  const response = await client.query<{
    getDiscoveryJourneySlides: DiscoveryJourneyApiResponse
  }>({
    query: DISCOVERY_JOURNEY_SLIDES_QUERY,
    fetchPolicy: "cache-first",
    context: {
      sessionStrategy: "REDIRECT_TO_LOGIN",
    },
  })

  return response.data.getDiscoveryJourneySlides.slides
}
